import Model from "./base/model";

class SimulationTableTrt extends Model{
  resourceName() {
    return "simulation_table_trt";
  }

  fields() {
    return {
      simulation_table_id: "",
      city_id: "",
      minimum_value: "",
      city: "",
      simulation_table: { jsonApi: "hasOne", type: "simulation_tables"},

    };
  }

}

export default new SimulationTableTrt();
